import { createAsyncThunk } from '@reduxjs/toolkit';
import { Dispatch, SetStateAction } from 'react';
import { claimPackageRankAsync, getRankingAsync } from './Ranking.requests';
import { ErrorToast } from '../../components';

export const getRanking = createAsyncThunk('getRanking', async () => {
  const { data } = await getRankingAsync();

  const sortedRewards = data?.packageRanks.map((rank) => ({
    ...rank,
    rewards: rank?.rewards?.sort(function (a, b) {
      return b?.reward?.type - a?.reward?.type;
    })
  }));

  const filteredRanks = sortedRewards?.filter(
    (rank) =>
      rank.packageRankId !== 12 &&
      rank.packageRankId !== 13 &&
      rank.packageRankId !== 14 &&
      rank.packageRankId !== 16 &&
      rank.packageRankId !== 17
  );

  return filteredRanks;
});

export const claimPackageRank = createAsyncThunk(
  'claimPackageRank',
  async (
    {
      selectedRank,
      setStep
    }: {
      selectedRank: any;
      setStep: Dispatch<SetStateAction<any>>;
    },
    { rejectWithValue }
  ) => {
    try {
      await claimPackageRankAsync(selectedRank?.rewards[0]?.id);
      setStep(2);
      return selectedRank.packageRankId;
    } catch (error: any) {
      ErrorToast(error.response.data.error);
      rejectWithValue(false);
    }
  }
);
